// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2378":"453c347077685870","6866":"a46ab4b385a626ba","8777":"bdb4b157217b5969"}[chunkId] + ".js";
};